import * as React from "react";

// add by Harper from the Noun Project
// https://thenounproject.com/term/add/1623623

export function FieldsAddIcon(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg viewBox="0 0 128 128" {...props}>
			<path d="M64 12.95a51.05 51.05 0 000 102.1 51.05 51.05 0 000-102.1z" />
			<path d="M84.42 68.5H68.5v16.22a4.8 4.8 0 01-4.5 4.8 4.65 4.65 0 01-4.5-4.8V68.5H43.58a4.5 4.5 0 01-4.5-4.5 4.35 4.35 0 014.2-4.5H59.5V43.28a4.8 4.8 0 014.5-4.8 4.65 4.65 0 014.5 4.8V59.5h15.92a4.5 4.5 0 014.5 4.5 4.35 4.35 0 01-4.2 4.5z" />
		</svg>
	);
}

// dots by Andrejs Kirma from the Noun Project (edited)
// https://thenounproject.com/term/dots/2915594

export function MoreFieldsBelowIcon(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg viewBox="0 0 25 4" {...props}>
			<circle cx={9} cy={2} r={2} />
			<circle cx={16} cy={2} r={2} />
			<circle cx={2} cy={2} r={2} />
		</svg>
	);
}
